<template lang="pug">
.gu24__search-line(:class="theme")
  input.gu24__search-line__input(type="search", @keyup="search", v-model="searchLine",
    :placeholder="$t('searchByEvents')", @focus="focus", v-if="isMobile")
  input.gu24__search-line__input(type="search", @keyup="search", v-model="searchLine",
    :placeholder="$t('searchByEvents')", @focus="focus", v-if="!isMobile")
  //- .gu24__search-line__icon
</template>

<script>
export default {
  name: 'Search',
  // props search->function
  props: {
    search: {
      type: Function,
      required: false,
      default: (e) => {
        // console.log('search default:', e, e.target.value);
      },
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    theme: {
      type: String,
      default: 'dark', // white or dark
      required: false,
    },
  },
  data: () => ({
    searchLine: '',
    timer: null,
    isMobile: false,
  }),
  watch: {
    value(val) {
      this.searchLine = val;
    },
  },
  mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
  },
  methods: {
    focus(e) {
      this.$emit('focus', e);
      this.clear();
      this.eventHub();
    },

    eventHub() {
      document.querySelector('body').removeEventListener('click', this.click, false);
      document.querySelector('body').addEventListener('click', this.click, false);
    },

    click(e) {
      const im = e.target;
      if (!im.classList.value.match('gu24__search')) { // gu24__search-results
        this.blur(e);
        return;
      }
      if (im.classList.value.match('gu24__search-results__item')) {
        this.clear();
        this.timer = setTimeout(() => {
          this.blur(e);
        }, 700);
      }
    },

    clear() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },

    blur(e) {
      this.$emit('blur', e);
      document.querySelector('body').removeEventListener('click', this.click, false);
    },
  },
};
</script>

<style lang="scss">
$--search-placeholder: rgb(102, 102, 102);
$--search-text: rgb(255, 255, 255);
$--search-bg: rgb(36, 36, 36);
$--search-icon: url('./images/dark.svg');

.white.gu24__search-line {
  font-family: 'Rubik', sans-serif;
  display: inline-block;
  width: 100%;
  max-width: 715 / 16 + rem;
  margin-left: 11.5625rem;
  position: relative;
  @media screen and (max-width: 960px) {
    margin-left: 1rem;
    width: 23vw;
  }
  &:after {
    content: '';
    position: absolute;
    right: .2875rem;
    top: 50%;
    transform: translateY(-50%);
    min-width: 2.75rem;
    min-height: 1.675rem;
    background-image: url('./images/white.svg');
    background-size: 12 / 16 + rem 12 / 16 + rem;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #ffde00;
    cursor: pointer;
    border-radius: 5px;
  }
}

.white .gu24__search-line__input {
  font-family: 'Rubik', sans-serif;
  appearance: none;
  width: 100%;
  border: 1 / 16 + rem solid rgb(228, 228, 228);
  border-radius: 3 / 16 + rem;
  background-color: rgb(255, 255, 255);
  font-size: 14 / 16 + rem;
  min-height: 2.25rem;
  padding: 0 20 / 16 + rem;
  @media screen and (max-width: 960px) {
    padding-left: .5rem;
    width: 23vw;
  }
  outline: none;
  &:focus {
    border-color: rgb(197, 197, 197);
  }
  &::placeholder {
    color: rgb(204, 204, 204);
  }
}

.dark.gu24__search-line {
  display: inline-block;
  min-width: 400 / 16 + rem;
  position: relative;
  &:after {
    content: '';
    position: absolute;
    right: 11 / 16 + rem;
    top: 50%;
    transform: translateY(-50%);
    min-width: 30 / 16 + rem;
    min-height: 30 / 16 + rem;
    background-image: $--search-icon;
    background-size: 12 / 16 + rem 12 / 16 + rem;
    background-repeat: no-repeat;
    background-position: center;
    background-color: $--search-bg;
    cursor: pointer;
  }
}
.dark .gu24__search-line__input {
  display: inline-block;
  font-family: 'Montserrat', sans-serif;
  font-size: 12 / 16 + rem;
  display: flex;
  appearance: none;
  width: 100%;
  border: none;
  outline: none;
  padding: 23 / 16 + rem 20 / 16 + rem 22 / 16 + rem;
  background-color: $--search-bg;
  color: $--search-text;
  margin: 0;
  max-height: 60 / 16 + rem;
  &::-webkit-input-placeholder {
    color: $--search-placeholder;
  }
  &::-moz-placeholder {
    color: $--search-placeholder;
  }
  &:-ms-input-placeholder {
    color: $--search-placeholder;
  }
  &:-moz-placeholder {
    color: $--search-placeholder;
  }
}
</style>
